<template>
    <div>
        <ion-grid>
            <ion-row>
                <ion-col>
                    <ion-list lines="none" inset="false" style="margin-bottom: 0;">
                        <ion-item>
                            <ion-skeleton-text animated style="height: 30px; width: 65%;"/>
                        </ion-item>
                        <ion-item>
                            <ion-skeleton-text animated style="height: 30px; width: 65%;"/>
                        </ion-item>
                        <ion-item>
                            <ion-skeleton-text animated style="height: 30px; width: 65%;"/>
                        </ion-item>
                    </ion-list>
                </ion-col>
                <ion-col>
                    <ion-item lines="none">
                        <ion-icon ios='calendar' md="calendar"></ion-icon>
                        <ion-label>
                            <ion-skeleton-text animated style="height: 30px; width: 65%;"/>
                        </ion-label>
                    </ion-item>
                </ion-col>
            </ion-row>
        </ion-grid>
        <div>
            <ion-card>
                <ion-card-header>
                    <ion-card-title>
                        <ion-skeleton-text animated style="height: 30px; width: 65%;"/>
                    </ion-card-title>
                </ion-card-header>
                <ion-card-content>
                    <ion-skeleton-text animated style="height: 30px; width: 65%;"/>
                </ion-card-content>
            </ion-card>
        </div>
    </div>
</template>

<script>
    export default {
        name: "MessageSkeleton",
    }
</script>
